import script from "./CreateSignal.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateSignal.vue?vue&type=script&setup=true&lang=js"

import "./CreateSignal.vue?vue&type=style&index=0&id=3a464f98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a464f98"]])

export default __exports__